var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberOfHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H11C11 12.4304 11.2754 12.8126 11.6838 12.9487L12 12ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7H13ZM14.6838 13.9487C15.2077 14.1233 15.774 13.8402 15.9487 13.3162C16.1233 12.7923 15.8402 12.226 15.3162 12.0513L14.6838 13.9487ZM13 12V7H11V12H13ZM11.6838 12.9487L14.6838 13.9487L15.3162 12.0513L12.3162 11.0513L11.6838 12.9487ZM21 12C21 16.9706 16.9706 21 12 21V23C18.0751 23 23 18.0751 23 12H21ZM12 21C7.02944 21 3 16.9706 3 12H1C1 18.0751 5.92487 23 12 23V21ZM3 12C3 7.02944 7.02944 3 12 3V1C5.92487 1 1 5.92487 1 12H3ZM12 3C16.9706 3 21 7.02944 21 12H23C23 5.92487 18.0751 1 12 1V3Z",
    fill: "#0573E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOfHours);
export default __webpack_public_path__ + "static/media/numberOfHours.cb992a1222a902594a3b658cbd44decc.svg";
export { ForwardRef as ReactComponent };